import { trackingAxios } from '../config/api/tracking'
import { DateISO } from 'interfaces/date'

export const getPackagesAvailable = async (dateStart?: DateISO, dateEnd?:DateISO) => {
    try {
        const headers = {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json',
        }

        const config = {
            headers: headers,
            params:{
                created_after_than: dateStart,
                created_before_than: dateEnd,
            }
        }
        const response = await trackingAxios.get(
            '/packages/available',
            config
        )
        return response.data
    } catch (e) {
        // Sentry.Native.captureException(e);
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        throw e.response.data
    }
}

export const createFile = async (file: File) => {  
    try {

        const formData = new FormData();
        formData.append('file', file);  

        const headers = {
            'X-Requested-With': 'XMLHttpRequest',
        };

        const config = {
            headers: headers,
        };


        const response = await trackingAxios.post(
            '/packages',
            formData, 
            config
        );

        return response.data;
    } catch (e) {
         // Sentry.Native.captureException(e);
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        throw e.response.data
    }
};